import React, { useEffect } from "react";
import { createPortal } from "react-dom";

// Reusable centered modal shell with overlay backdrop.
// Closes when clicking outside (overlay). Traps z-layer at z-[62].
export default function CenteredModal({
  open,
  onClose,
  children,
  maxWidth = "max-w-sm",
  maxHeight = "max-h-[80dvh]",
}) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[62] flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.45)" }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className={`bg-white dark:bg-slate-800 rounded-[24px] w-full ${maxWidth} ${maxHeight} flex flex-col shadow-[0_8px_40px_rgba(0,0,0,0.22)] overflow-hidden`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
